import { ACCOUNT_BUSINESS_UNIT_ID } from 'FormsCommonComponents/constants/BusinessUnits';
// @ts-expect-error missing types
import { getSubscriptionDefinitions } from 'FormsCommonComponents/selectors/LegalConsent';
import { isUngatedForCampaignBusinessUnit as getIsUngatedForCampaignBusinessUnit } from 'FormsUI/selectors/Gates';
import { hasBusinessUnitsAccess as getHasBusinessUnitsAccess } from 'FormsUI/selectors/BusinessUnitsAccess';
import getUnselectedSubscriptionsForLegalConsent from 'FormsUI/selectors/legalConsent/getUnselectedSubscriptionsForLegalConsent';
// @ts-expect-error missing types
import { getBusinessUnitId } from 'FormsUI/selectors/FormDefinition';
export const getBusinessUnitIdForLegalConsentCheckbox = (state, checkbox) => {
  const businessUnitId = getBusinessUnitId(state);
  const hasBusinessUnitsAccess = getHasBusinessUnitsAccess(state);
  const subscriptionsDefinitions = getSubscriptionDefinitions(state);
  const subscriptions = getUnselectedSubscriptionsForLegalConsent(state);

  // TODO: when this gets removed this whole file is not needed anymore
  // replace it's usage by getBusinessUnitId selector
  const isUngatedForCampaignBusinessUnit = getIsUngatedForCampaignBusinessUnit(state);
  if (hasBusinessUnitsAccess && isUngatedForCampaignBusinessUnit) {
    return businessUnitId;
  } else {
    const fallbackSubscription = subscriptions.length ? subscriptions[0].id : undefined;
    const subscriptionId = checkbox ? checkbox.communicationTypeId : fallbackSubscription;
    const subscription = subscriptionsDefinitions.find(({
      id
    }) => id === subscriptionId);
    return subscription ? subscription.businessUnitId : ACCOUNT_BUSINESS_UNIT_ID;
  }
};
export default getBusinessUnitIdForLegalConsentCheckbox;